export default __webpack_public_path__ + "static/media/mail.a456cf0c.png";